import mixpanel from "mixpanel-browser";

mixpanel.init("82d5d2e534d6452d915ca5b257059180", {
  debug: process.env.NODE_ENV !== "production",
});

export default mixpanel;
